import { Field, Text } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'lib/ComponentProps';

import styles from './ResourceOverviewPageLink.module.css';

type ResourceOverviewPageLink = ComponentProps & {
	fields: {
		OverviewPageLink: {
			text: string;
			url: string;
		};
		FromText: Field<string>;
	};
};

export default function ResourceOverviewPageLink(props: ResourceOverviewPageLink): JSX.Element {
	return (
		<section className={`${styles.overviewPageLink} maxWidth`}>
			<span>
				<Text field={props.fields?.FromText}></Text>
			</span>
			<a href={props.fields?.OverviewPageLink?.url} className={`${styles.link} ${styles.underline}`}>
				<span>{props.fields?.OverviewPageLink?.text}</span>
			</a>
		</section>
	);
}
